import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const getSupportDetailSlice = createSlice({
  name: "getSupportDetail",
  initialState,
  reducers: {
    getSupportDetailRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSupportDetailRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    getSupportDetailRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getSupportDetailRequest,
  getSupportDetailRequestSuccess,
  getSupportDetailRequestError,
} = getSupportDetailSlice.actions;

export default getSupportDetailSlice.reducer;
